export interface SelectOption {
  id: string;
  value: string;
}

export function selectOptionActions() {
  function create(id: string, value: string): SelectOption {
    return {
      id: id,
      value: value,
    };
  }

  return {
    create,
  };
}
